export default __webpack_public_path__ + "static/media/mall-ico-active.e718a2bf.svg";